/**
 * Thông tin ứng dụng đọc từ biến môi trường lúc build (CRA nhúng thẳng REACT_APP_* vào
 * bundle — không đặt secret ở đây). Xem mẫu trong `.env.example`.
 */

const read = (value: string | undefined) => (value || '').trim();

export const APP_NAME = 'Quản trị HP Media';

/** `localhost` | `develop` | `uat` | `production`. Rỗng coi như production. */
export const APP_ENV = read(process.env.REACT_APP_ENV);

/**
 * Phiên bản mặc định ở chân trang xác thực — GIỮ KHỚP trường "version" trong
 * admin-hp-media-staging/package.json mỗi lần nâng phiên bản. Để hằng ở đây vì file .env bị
 * .gitignore (.env*), nên bản dev lẫn bản build vẫn có số phiên bản khi không đặt biến nào.
 */
const DEFAULT_APP_VERSION = '0.1.0';

/** `REACT_APP_VERSION` nếu đặt (vd. CI gắn số build) sẽ ghi đè DEFAULT_APP_VERSION. */
export const APP_VERSION = read(process.env.REACT_APP_VERSION) || DEFAULT_APP_VERSION;

// Chỉ nhận http(s)/mailto/tel để một giá trị cấu hình sai (vd. "javascript:") không thành link.
const SAFE_LINK = /^(https?:\/\/|mailto:|tel:)/i;
const rawSupportUrl = read(process.env.REACT_APP_SUPPORT_URL);

/** Kênh hỗ trợ thật (Zalo OA, email nhóm...). Rỗng thì ẩn link "Hỗ trợ" và nút "Liên hệ Admin". */
export const SUPPORT_URL = SAFE_LINK.test(rawSupportUrl) ? rawSupportUrl : '';
export const SUPPORT_LABEL = read(process.env.REACT_APP_SUPPORT_LABEL) || 'Hỗ trợ';

/**
 * Đăng ký tài khoản ngay trên trang quản trị. Mặc định BẬT; đặt
 * `REACT_APP_ENABLE_SIGNUP=false` để tắt — khi đó /register chuyển sang /request-access.
 */
export const SIGNUP_ENABLED = read(process.env.REACT_APP_ENABLE_SIGNUP).toLowerCase() !== 'false';

const ENV_LABELS: Record<string, string> = {
  localhost: 'LOCAL',
  local: 'LOCAL',
  develop: 'DEV',
  development: 'DEV',
  dev: 'DEV',
  uat: 'UAT',
  staging: 'STAGING',
};

/**
 * Nhãn môi trường hiện trên trang xác thực. `null` khi là production (hoặc chưa đặt biến):
 * bản production mà vẫn hiện nhãn tức là build quên đặt REACT_APP_ENV=production.
 */
export function envLabel(env: string = APP_ENV): string | null {
  const key = env.trim().toLowerCase();
  if (!key || key === 'production' || key === 'prod') return null;
  return ENV_LABELS[key] || key.toUpperCase();
}

/** Tiêu đề tab trình duyệt: "[UAT] Đăng nhập · Quản trị HP Media". */
export function documentTitle(pageTitle?: string): string {
  const label = envLabel();
  const base = pageTitle ? `${pageTitle} · ${APP_NAME}` : APP_NAME;
  return label ? `[${label}] ${base}` : base;
}

/**
 * Cờ trong sessionStorage để màn Đăng nhập báo lý do bị đưa về (vd. 'expired' khi phiên
 * hết hạn / bị đăng nhập ở nơi khác). Ghi ở utils/axios-utils.ts, đọc-rồi-xoá ở trang Đăng nhập.
 */
export const AUTH_NOTICE_KEY = 'hp-auth-notice';

/**
 * Các trang xác thực công khai. Lỗi 401/403 xảy ra khi đang ở đây không được tải lại trang
 * về /login (sẽ nuốt mất thông báo lỗi đang hiện).
 */
export const PUBLIC_AUTH_PATHS = [
  '/login',
  '/register',
  '/forgot-password',
  '/request-access',
  '/send-mail-forgot-password',
  '/sso',
];
